package team.platforma.chat_data.database.chats

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.emptyFlow
import kotlinx.coroutines.flow.transform
import team.platforma.chat_data.model.ChatData
import team.platforma.chatdata.database.ChatDatabase
import team.platforma.chatdata.table.Draft

class ChatsTableImpl(
    private val chatDatabase: ChatDatabase
) : ChatsTable {
    override suspend fun insertChat(chat: ChatData) {
        chatDatabase.mokChatQueries.insertChat(
            id = chat.id,
            aiModelId = chat.aiModelId,
            userId = chat.userId,
            name = chat.name
        )
    }

//    override suspend fun updateDraft(draftId: Long, text: String, chatId: Long) {
//        chatDatabase.draftQueries.updateDraft(
//            text = text,
//            chatID = chatId,
//            draftID = draftId
//        )
//    }

    override fun observeAiChats(
        aiModelID: Long?,
        userID: Long
    ): Flow<List<ChatData>> {
        return if (aiModelID == null) {
            emptyFlow()
        } else {
            chatDatabase.mokChatQueries.observeChats(aiModelID, userID).asFlow()
                .mapToList(Dispatchers.Default).transform { value ->
                    val list = value.map {
                        ChatData(
                            id = it.id,
                            aiModelId = it.aiModelId,
                            userId = it.userId,
                            name = it.name
                        )

                    }
                    print("list: $list")
                    return@transform emit(list.reversed())
                }
        }
    }

}